import React, {useEffect} from "react";
import "./styles.scss";
import "./mobile.scss";
import {withRouter} from "react-router-dom/cjs/react-router-dom.min";
import {FormHeader, Navigator, SectionHeader} from "../../../components";
import {getLanguage} from "../../../utils/environment";
import Footer from "../../footer/index";
import {useLocation} from "react-router-dom/cjs/react-router-dom";

const ReturnPolicy = (props) => {
  const len = getLanguage();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({top: 0, behavior: "smooth"});
  }, [location.pathname]);

  return (
    <>
      <div className="container">
        <Navigator
          data={{ size: "lg", icon: "arrow-left", title: "Refund Policy" }}
          onClickBack={() => {
            props.history.push("/");
          }}
        />
        <div className={"policy-wrapper"}>
          <div className={"pw__top"}>
            <FormHeader
              data={{
                size: "lg x",
                mainLayerStyles: "mb-4 pb-2",
                formHeader: "Refund Policy",
              }}
            />
            <SectionHeader
              data={{
                size: "md x",
                title: "",
              }}
            />
          </div>
          <div className={"pw__body"}>
            <p>
              Last Updated: 25 Jub 2025

              At hopeofanewera.org,
              we are committed to providing high-quality services to our users. This Refund Policy outlines the
              circumstances under which refunds may be issued for our various services.

            </p>

            <h2> Subscriptions</h2>
            <p>
              Subscriptions provide access to premium news content and features.
              <ul>
                <li>Free Trial (if applicable): If you are on a free trial, you will not be charged unless you continue
                  after the trial ends.
                </li>
                <li>Monthly/Yearly Plans.</li>
                <li>Refunds are not provided for partial subscription periods (e.g., if you cancel mid-month).</li>
                <li>You may cancel anytime, and access will continue until the end of the billing cycle.</li>
              </ul>
              Exceptions: If you were mistakenly charged or experienced technical issues that prevented access to
              subscribed content, please contact us at [support@hopeofanewera.org] within 7 days of the issue for
              review.
            </p>

            <h2> Paid Advertisements</h2>
            <p>
              We offer paid advertising space on our platform.
              <ul>
                <li>Ad Approval: Once an ad is approved and goes live, no refunds will be issued.
                </li>
                <li>Monthly/Yearly Plans.</li>
                <li>Disapproved Ads: If an ad is disapproved and you do not wish to revise or resubmit, you may be
                  eligible for a full or partial refund upon request.
                </li>
                <li>Service Failure: If your ad did not run due to a platform error or scheduling fault, you may request
                  a prorated refund or credit.
                </li>
              </ul>

            </p>

            <h2>Donations</h2>
            <p>
              Donations are voluntary contributions that support our mission.
              <ul>
                <li>Non-Refundable: All donations are considered final and non-refundable.
                </li>
                <li>Monthly/Yearly Plans.</li>
                <li>If you believe a donation was made in error or unauthorized, please contact us at
                  contact@hopeofanewera.org within 7 days.
                </li>
              </ul>
            </p>

            <h2>How to Request a Refund</h2>
            <p>
              If you believe you are eligible for a refund under this policy, please contact us with the following:
              <ul>
                <li>Your name and account email.</li>
                <li>Date and description of the transaction.</li>
                <li>Reason for the refund request.</li>
              </ul>
            </p>

            <h2>Policy Changes</h2>
            <p>
              We reserve the right to update this Refund Policy at any time. Changes will be posted on this page with an
              updated date.
            </p>


          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default withRouter(ReturnPolicy);
